import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=9d28fc2a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d28fc2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d28fc2a')) {
      api.createRecord('9d28fc2a', component.options)
    } else {
      api.reload('9d28fc2a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=9d28fc2a&scoped=true&", function () {
      api.rerender('9d28fc2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hZPLJb8rdG3R/JS/comp/SearchFilterTokens.vue"
export default component.exports